import { IImageBlock } from "@/lib/types";
import React from "react";
import Image from "next/image";

interface UserImageProps {
    image: IImageBlock;
}

export const UserImage = ({ image }: UserImageProps) => {
    return (
        <div className={"flex flex-row items-start bg-blue-200 rounded-xl py-2 px-4 mb-4"}>
            <Image
                src={`data:image/${image.format};base64,${image.source.bytes}`}
                alt={"Uploaded image"}
                width={0}
                height={0}
                className={"w-32 h-auto max-w-32 rounded-md"}
            ></Image>
        </div>
    );
};
